import {
    CreateDealerAnnouncementDTO,
    DealerAnnouncementClient_V1,
    DealerAnnouncementDocumentDTO,
    DealerAnnouncementDTO,
    DeleteDealerAnnouncementDocDTO,
    DocumentDTO,
} from './generated/api.generated.v1';
import ApiConfig from './ApiConfig';
import { ApiHelper } from 'src/utils';

export default class AnnouncementService {
    private readonly _dealerAnnouncementClient: DealerAnnouncementClient_V1;

    constructor() {
        this._dealerAnnouncementClient = new DealerAnnouncementClient_V1(new ApiConfig(), process.env.VUE_APP_API_V1_URL);
    }

    public Announcements() : Promise<DealerAnnouncementDTO[]> {
        return this._dealerAnnouncementClient.announcements();
    }
    public CreateAnnouncement(dto: CreateDealerAnnouncementDTO) : Promise<CreateDealerAnnouncementDTO> {
        return ApiHelper.ParseDTO<CreateDealerAnnouncementDTO>(() => this._dealerAnnouncementClient.createAnnouncement(dto));
    }
    public UpdateAnnouncement(dto: DealerAnnouncementDTO) : Promise<DealerAnnouncementDTO> {
        return ApiHelper.ParseDTO<DealerAnnouncementDTO>(() => this._dealerAnnouncementClient.updateAnnouncement(dto));
    }
    public RemoveAnnouncement(dto: DealerAnnouncementDTO) : Promise<DealerAnnouncementDTO> {
        return ApiHelper.ParseDTO<DealerAnnouncementDTO>(() => this._dealerAnnouncementClient.deleteAnnouncement(dto));
    }
    public AnnouncementAttachments(dealerAccountUid : string) : Promise<Array<DocumentDTO>> {
        return this._dealerAnnouncementClient.announcementDocuments(dealerAccountUid);
    }
    public CreateAnnouncementAttachments(dto : DealerAnnouncementDocumentDTO) : Promise<DealerAnnouncementDocumentDTO> {
        return ApiHelper.ParseDTO<DealerAnnouncementDocumentDTO>(() => this._dealerAnnouncementClient.createAnnouncementDocument(dto));
    }
    public RemoveAnnouncementAttachment(dto : DeleteDealerAnnouncementDocDTO) : Promise<DeleteDealerAnnouncementDocDTO> {
        return ApiHelper.ParseDTO<DeleteDealerAnnouncementDocDTO>(() => this._dealerAnnouncementClient.deleteAnnouncementDocument(dto));
    }
}